/**
 * @param {string} value
 * @returns {string}
 */
export default function normalizeVoiceE164(value) {
  if (!value || typeof value !== 'string') return '';
  let normalized = value.trim().replace(/[^\d+]/g, '');
  normalized = normalized.replace(/^\++/, '+');
  if (!normalized) return '';
  if (!normalized.startsWith('+')) {
    normalized = `+${normalized.replace(/\+/g, '')}`;
  }
  return normalized.replace(/^\+(0+)/, '+');
}
